<template>
  <div id="ProjProNewInviteSupplier">
    <ProjProNewHeader/>
    <ProjectViewSummary :project="project" class="panel-box" />
    <div class="eb-line"></div>
    <ProjectEditInvitesupplier @onBuyScopeChange="onBuyScopeChange" :project="project" class="panel-box" />
    <div class="eb-line"></div>
    <ProjectEditInvitesupplierList v-if="project&&project.buyScope=='1'" :supplierList="supplierList" :isSupplierListLoading="isSupplierListLoading" @onSupplierListCreated="onSupplierListCreated" @onSupplierListPagination="onSupplierListPagination" @onSupplierListDel="onSupplierListDel" :listSupplier="listSupplier" :isListSupplierLoading="isListSupplierLoading" @inviteListSupplierClick="inviteListSupplierClick" @onListSupplierPagination="onListSupplierPagination" @onChooseSupplierClick="onChooseSupplierClick" @onSearchListSupplier="onSearchListSupplier" class="panel-box" />
    <div class="eb-line" v-if="project&&project.buyScope=='1'"></div>
    <div class="eb-button-group">
      <router-link class="eb-button-group-btn" :to="{path:'/projpro/new/purchaselist/'+projectId}">
        <el-button class="eb-button-orange eb-button-big"> &lt; 采购清单</el-button>
      </router-link>
      <router-link class="eb-button-group-btn" :to="{path:'/projpro/new/preview/'+projectId}">
        <el-button class="eb-button-orange eb-button-big">预览项目 &gt;</el-button>
      </router-link>
    </div>
  </div>
</template>
<script>
import ProjProNewHeader from '@/components/project/pro/new/ProjProNewHeader';
import ProjectViewSummary from '@/components/project/common/ProjectViewSummary';
import ProjectEditInvitesupplier from '@/components/project/common/ProjectEditInvitesupplier';
import ProjectEditInvitesupplierList from '@/components/project/common/ProjectEditInvitesupplierList';
import { getProjectById, editProject } from '@/services/proj/pro-project-service';
import { supplierList, listSupplier, saveIS, deleteIS } from '@/services/proj/pro-supplier-list-service';
export default {
  name: 'ProjProNewInviteSupplier',
  components: {
    ProjProNewHeader,
    ProjectViewSummary,
    ProjectEditInvitesupplier,
    ProjectEditInvitesupplierList
  },
  data() {
    return {
      projectId: this.$route.params.projectId,
      user: this.$store.state.user.userInfo,
      project: {},
      supplierList: {
        data: []
      },
      listSupplier: {
        data: []
      },
      isSupplierListLoading: true,
      isListSupplierLoading: true
    };
  },
  created() {
    this.initProject();
  },
  methods: {
    // 获取项目信息service
    async projectByIdService() {
      try {
        let { data } = await getProjectById({ projectId: this.projectId });
        if (data.returnCode !== '01') {
          if (data.codeText) {
            this.$message.error(data.codeText);
          } else {
            this.$message.error('获取项目信息失败');
          }
        }
        return { data };
      } catch (error) {
        this.$message.error(error.message);
      }
    },
    // 修改项目service
    async editProjectService(buyScope) {
      let params = {
        projectId: this.projectId,
        updateId: this.user.userid,
        buyScope: buyScope
      };
      try {
        let { data } = await editProject(params);
        if (data.returnCode !== '01') {
          this.$message.error('修改项目采购范围失败');
        }
        return { data };
      } catch (error) {
        this.$message.error(error.message);
      }
    },
    // 已邀请供应商列表service
    async supplierListService(start) {
      let params = {
        start: start || 0,
        length: 10,
        projectId: this.projectId
      };
      try {
        let { data } = await supplierList(params);
        if (data.returnCode === '01') {
        } else {
          this.$message.error('获取已选中供应商列表失败，请稍后重试');
        }
        return { data };
      } catch (error) {
        this.$message.error(error.message);
      }
    },
    // 删除已邀请供应商service
    async deleteISService(inviteIds) {
      try {
        let { data } = await deleteIS(this.projectId, inviteIds);
        if (data.returnCode === '01') {
          this.$message.success('已从邀请列表删除供应商');
        } else {
          this.$message.error('邀请列表删除供应商失败');
        }
        return { data };
      } catch (error) {
        this.$message.error(error.message);
      }
    },
    // 供应商列表service
    async listSupplierService(start, content) {
      let params = {
        start: start || 0,
        length: 10,
        projectId: this.projectId,
        content: content || ''
      };
      try {
        let { data } = await listSupplier(params);
        if (data.returnCode === '01') {
        } else {
          this.$message.error('获取供应商列表失败，请稍后重试');
        }
        return { data };
      } catch (error) {
        this.$message.error(error.message);
      }
    },
    // 保存供应商service
    async saveISService(supplierIds) {
      try {
        let { data } = await saveIS(this.projectId, supplierIds);
        if (data.returnCode === '01') {
          this.$message.success('已成功保存邀请供应商列表');
        } else {
          this.$message.error('保存邀请供应商列表失败');
        }
        return { data };
      } catch (error) {
        this.$message.error(error.message);
      }
    },
    async initProject() {
      this.$root.layout.isLoading = true;
      let { data } = await this.projectByIdService();
      if (data && data['project']) {
        this.project = data.project;
      }
      this.$root.layout.isLoading = false;
    },
    // 点击采购范围radio的回调，返回选中的buyScope值
    async onBuyScopeChange(val) {
      await this.editProjectService(val);
    },
    // 已邀请供应商列表初始化回调
    async onSupplierListCreated() {
      this.isSupplierListLoading = true;
      let { data } = await this.supplierListService();
      if (data && data['data']) {
        this.supplierList = data;
      } else {
        this.supplierList = { data: [] };
      }
      this.isSupplierListLoading = false;
    },
    // 已选供应商分页
    async onSupplierListPagination(result) {
      this.isSupplierListLoading = true;
      let { data } = await this.supplierListService((result - 1) * 10 > 0 ? (result - 1) * 10 : 0);
      if (data && data['data']) {
        this.supplierList = data;
      }
      this.isSupplierListLoading = false;
    },
    // 删除供应商
    async onSupplierListDel(result) {
      this.isSupplierListLoading = true;
      await this.deleteISService(result.arr.join(','));
      await this.onSupplierListCreated();
      result.next();
    },
    // 点击邀请按钮回调
    async inviteListSupplierClick(result) {
      this.isListSupplierLoading = true;
      let { data } = await this.listSupplierService();
      if (data && data['data']) {
        this.listSupplier = data;
      }
      this.isListSupplierLoading = false;
      result.next();
    },
    // 供应商列表分页
    async onListSupplierPagination(result) {
      this.isListSupplierLoading = true;
      let { data } = await this.listSupplierService((result.value - 1) * 10 > 0 ? (result.value - 1) * 10 : 0);
      if (data && data['data']) {
        this.listSupplier = data;
      }
      this.isListSupplierLoading = false;
      result.next();
    },
    // 供应商列表点击确定事件
    async onChooseSupplierClick(result) {
      await this.saveISService(result.arr.join(','));
      await this.onSupplierListCreated();
      result.next();
    },
    // 搜索供应商
    async onSearchListSupplier(result) {
      this.isListSupplierLoading = true;
      let { data } = await this.listSupplierService(0, result.value);
      if (data && data['data']) {
        this.listSupplier = data;
      }
      this.isListSupplierLoading = false;
    }
  }
};
</script>
<style scoped lang="less">
</style>
